export default __webpack_public_path__ + "static/media/newClient.915199de.png";